export default {
  header: {
    title: 'Belohnungen',
  },
  content: {
    title: 'Du hast {{balance}} Punkte',
    description:
      'Gib {{amount}} aus, erhalte {{rewards}} Punkte! Füge kostenlose Artikel zu deinem Warenkorb hinzu mit deinen verdienten Punkten.',
    articles: {
      title: 'Verdiene Punkte bei jeder Bestellung',
      spend_description: 'Jeder {{amount}} den du ausgibst, fügt {{rewards}} Punkte zu deinem Konto hinzu.',
      redeem_description:
        'Löse deine Punkte für kostenlose Leckereien ein! Beginne Belohnungen zu verdienen bei {{minSpendingLimit}} Punkten, was {{amount}} ausgegeben entspricht',
      discounts_description:
        'Entdecke exklusive Angebote, Aktionen und Rabatte. Schau in der App nach Mitglieder-Only-Promotionen.',
    },
  },
};
